import { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "utils/@reduxjs/toolkit";
import {
  initialAdminCatalogForm,
  initialAdminCatalogItemForm,
  initialState,
} from "./initialState";
import {
  AdminCatalogForm,
  AdminCatalogItemForm,
  AdminCatalogState,
  InfluenceField,
  VisualIntegration,
} from "../types/index";

export const sliceKey = "AdminCatalogState";

const AdminCatalogSlice = createSlice({
  name: sliceKey,
  initialState,
  reducers: {
    openAddModal(state) {
      state.isAddModalOpen = true;
    },

    closeAddModal(state) {
      state.isAddModalOpen = false;
      state.form = initialAdminCatalogForm;
    },

    setFormField(
      state,
      action: PayloadAction<{
        name: keyof AdminCatalogForm;
        value: string;
      }>
    ) {
      const { name, value } = action.payload;
      state.form[name] = value;
    },

    addCatalog(state) {
      const { catalogName, description, amountOfItems, mainInfluenceField, visualIntegration } =
        state.form;
      const nextId = Math.max(0, ...state.catalogData.map((row) => row.id)) + 1;

      state.catalogData.unshift({
        id: nextId,
        catalogName,
        description,
        amountOfitems: amountOfItems,
        mainInfluenceField: mainInfluenceField as InfluenceField,
        visualIntegration: visualIntegration as VisualIntegration,
      });
      state.isAddModalOpen = false;
      state.form = initialAdminCatalogForm;
    },

    openAddItemModal(state) {
      state.isAddItemModalOpen = true;
    },

    closeAddItemModal(state) {
      state.isAddItemModalOpen = false;
      state.itemForm = initialAdminCatalogItemForm;
    },

    setItemFormField(
      state,
      action: PayloadAction<{
        name: keyof AdminCatalogItemForm;
        value: string;
      }>
    ) {
      const { name, value } = action.payload;
      state.itemForm[name] = value;
    },

    addCatalogItem(state) {
      const nextId = Math.max(0, ...state.CatalogItems.map((item) => item.id)) + 1;
      state.CatalogItems.unshift({ id: nextId, ...state.itemForm });
      state.isAddItemModalOpen = false;
      state.itemForm = initialAdminCatalogItemForm;
    },

    setMainInfluenceField: (
      state: AdminCatalogState,
      action: PayloadAction<{ id: number; influenceField: InfluenceField }>
    ) => {
      const row = state.catalogData.find((item) => item.id === action.payload.id);
      if (row) {
        row.mainInfluenceField = action.payload.influenceField;
      }
    },
    setVisualIntegration: (
      state: AdminCatalogState,
      action: PayloadAction<{ id: number; visualIntegration: VisualIntegration }>
    ) => {
      const row = state.catalogData.find((item) => item.id === action.payload.id);
      if (row) {
        row.visualIntegration = action.payload.visualIntegration;
      }
    },
  },
});

export const { reducer, actions: adminCatalogActions } = AdminCatalogSlice;
